// extracted by css-extract-rspack-plugin
export default {"promptInput":"promptInput-vXXI6w","topLeftC":"topLeftC-zqjjCD","title":"title-FRAfxa","textarea":"textarea-HptziJ"};